/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieGridItemViewModelPaginatedResponse } from "../types/SerieGridItemViewModelPaginatedResponse.ts";
import { serieGridItemViewModelSchema } from "./serieGridItemViewModelSchema.ts";

export const serieGridItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => serieGridItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<SerieGridItemViewModelPaginatedResponse>;
